// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#mainPageSwitch1 span{max-width:2.604vw;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.canvas-container{position:fixed!important;bottom:0!important;left:0!important}.centralTable .el-table__body-wrapper{height:15.104vw!important;overflow-y:auto!important}#HPIndex .warning-row{background:rgba(245,108,108,.1);color:#f56c6c}", ""]);
// Exports
module.exports = exports;
